module.exports = __webpack_public_path__ + "img/e_education.b029b468.png";